export class Address {
	readonly id: number;
	label: string;
	latitude: number;
	longitude: number;

	constructor(
		options: {
			label?: string;
			latitude?: number;
			longitude?: number;
		} = {}
	) {
		this.label = options.label || 'Non spécifié';
		this.latitude = options.latitude || 0.0;
		this.longitude = options.longitude || 0.0;
	}
}
